// ShopCatalog.js
import Helmet from 'components/Helmet'
import Banner from 'features/Shop/components/Banner'
import ProductCatalog from 'features/Shop/components/ProductCatalog'
import './styles.scss'

function ShopCatalog() {
  return (
    <Helmet title="Shop">
      <div className="shop-catalog">
        <div className="shop-banner">
          <Banner />
        </div>
        <div className="shop-product">
          <ProductCatalog />
        </div>
      </div>
    </Helmet>
  )
}

export default ShopCatalog
